export default __webpack_public_path__ + "static/media/logo-icon.f8a82f7e.png";